import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UserPermissions } from '../../models/user-permissions.model';
import { AppState } from '../../store';
import { Store, select } from '@ngrx/store';
import { selectUserPermissions } from '../../store/selectors';
import { Subscription } from 'rxjs';
import { FeatureFlags } from '../../models/feature-flag.model';
import { featuresConfig } from '../../feature-flag.config';


@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService implements OnDestroy {
  private permissions: UserPermissions;
  public features: FeatureFlags;
  private subscription: Subscription = new Subscription();

  constructor(private store: Store<AppState>) {
    this.subscription.add(
      this.store.pipe(select(selectUserPermissions)).subscribe(permissions => {
        this.permissions = permissions;
        this.initializeFeatures();
      })
    );
  }

  private initializeFeatures(): void {
    let  featuresList: any = { ...featuresConfig };
    for(let feature in featuresList) {
      featuresList[feature] = this.isFeatureActive(featuresList[feature]);
    }
    this.features = featuresList;
  }

  private isFeatureActive(value: any): boolean {
    switch (value) {
      case 'DEVELOPMENT':
        return !environment.production;
      case 'QA-TEST':
        return !!this.permissions?.isPlatformAdmin;
      case 'LIVE':
        return true;
      default:
        return false;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}